import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';

class VocabularyThemeForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    values: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    isDirty: PropTypes.func,
  };

  static defaultProps = {
    values: {},
    errors: {},
    submitting: false,
    isDirty: () => false,
    onSubmit: () => alert('submitted'),
    onReset: () => false,
  };

  render() {
    return (
      <form
        onSubmit={(event) => {
          event.preventDefault();
          this.props.onSubmit();
        }}
      >
        <Row>
          <Column size={12}>
            <TextInput
              required
              disabled={this.props.submitting}
              label="Name"
              value={get(this.props.values, 'name', '')}
              onChange={(value) => this.props.onChange('name', value)}
              errorText={get(this.props.errors, 'name', null)}
            />
          </Column>
        </Row>
        <FormButtons
          confirmLabel={this.props.values.id ? 'Update Vocabulary Theme' : 'Create Vocabulary Theme'}
          isDisabled={this.props.submitting || !this.props.isDirty()}
          isSubmitting={this.props.submitting}
          onReset={this.props.onReset}
        />
      </form>
    );
  }
}

export default VocabularyThemeForm;
